import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "@/api/client";
import type { components } from "@/api/schema";

import { promotionKeys } from "./query-keys";

type CreateCampaignBody = components["schemas"]["CreateCampaignRequest"];

export function useCreateCampaign() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (body: CreateCampaignBody) => {
      const { data, error } = await apiClient.POST("/v1/campaigns", { body });
      /* v8 ignore next -- unreachable: client errorMiddleware throws ApiError on !ok */
      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: promotionKeys.all });
    },
  });
}
